import React, { useContext } from "react";
import Icon, { IconName } from "../icon";
import AuthContext from "../../services/firebase/auth-context/provider";
import { navigate } from "gatsby";
var LoginLink = function LoginLink(_ref) {
    var onClick = _ref.onClick, color = _ref.color;
    var authContext = useContext(AuthContext);
    var authenticated = authContext[0].authenticated;
    var navigateToAccount = function navigateToAccount() {
        return navigate("/anmelden/");
    };
    var tooltip = authenticated ? "Account Übersicht" : "Anmelden";
    return /*#__PURE__*/ React.createElement("div", {
        className: "inline-block ml-2 cursor-pointer",
        onClick: !authenticated ? onClick : navigateToAccount
    }, /*#__PURE__*/ React.createElement(Icon, {
        iconName: IconName.LOGIN,
        className: "text-" + color + " w-6 lg:w-8",
        tooltip: tooltip,
        color: "current-color"
    }));
};
export default LoginLink;
